import i18n from '@/plugins/i18n';
import newhttp from '~/http/new';

export default ({
  state: {
    data: [],
  },

  mutations: {
    SET_DATA(state, data) { state.data = data; },
  },

  actions: {
    async loadData({ commit }) {
      const response = await newhttp.get('/v1/settings/trade-timers');
      const { setting } = response.data;
      commit('SET_DATA', setting);
    },

    async updateTimersSettings(__store, data) {
      const response = await newhttp.put('/v1/settings/trade-timers', data);
      if (!response.data.result.Success) {
        switch (response.data.result.Error) {
          case 'Object reference not set to an instance of an object.':
            throw new Error(i18n.t('notification.Object is not correct'));
          default:
            throw new Error(i18n.t('Unexpected error'));
        }
      }
    },
  },

  namespaced: true,
});
